import { c as _c } from "react/compiler-runtime";
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { getLogger } from '@/idv2/utils/logger';
const {
  logInfo
} = getLogger({
  name: 'idv2',
  location: 'identify'
});
export const Route = createFileRoute('/identify')({
  // Logged rather than tracked, as idv's router does: RUM keeps only a sample of sessions, and the
  // identify ramp compares these counts per engine and tenant. reportIdentifyDone logs the end.
  onEnter: () => logInfo('Identify started', {
    engine: 'idv2'
  }),
  component: IdentifyLayout
});
function IdentifyLayout() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Outlet />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}